<template>
  <s-field v-bind="props">
    <template v-slot="a11yProps">
      <s-searchable-select
        v-bind="{...a11yProps, ...$attrs}"
        v-model="model"
        :required="required"
        :options="options"
        :disabled="disabled"
        :placeholder="placeholder"
      >
        <template v-if="$slots.option" #option="{option}">
          <slot name="option" v-bind="{option}" />
        </template>
      </s-searchable-select>
    </template>
    <template v-if="$slots.label" #label>
      <slot name="label" />
    </template>
    <template v-if="tooltip || $slots.tooltip" #tooltip>
      <slot name="tooltip" />
    </template>
  </s-field>
</template>

<script setup lang="ts" generic="T extends Option">
import {type VNode} from 'vue';
import SField from './SField.vue';
import SSearchableSelect from './SSearchableSelect.vue';
import type {Option} from './controls/Option';

defineOptions({
  inheritAttrs: false,
});

const model = defineModel<T['value'] | null>();

const props = defineProps<{
  id: string;
  label?: string | null;
  description?: string | null;
  tooltip?: string | VNode | null;
  error?: string | null;
  required?: boolean;
  class?: string | Record<string, boolean | string>;
  options: T[];
  disabled?: boolean;
  placeholder?: string;
}>();
</script>
